function getCarTypeName(carTypes, value) {
  if (!Array.isArray(carTypes)) return '';
  const match = carTypes.find((item) => item && item.value === value);
  return match && typeof match.name === 'string' ? match.name : '';
}

module.exports = { getCarTypeName };
